import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import AccountSumUtils from "../../UtilComponents/AccountSumUtils";
import { MarketOverview } from "react-ts-tradingview-widgets";
import { StockMarket } from "react-ts-tradingview-widgets";
import { Timeline } from "react-ts-tradingview-widgets";
import { CryptoCurrencyMarket } from "react-ts-tradingview-widgets";

export default function UDMktOverviewUi({ pathname }) {
	return (
		<Box
			sx={{
				py: 4,
				px: "0.9rem",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				textAlign: "center",
			}}>
			<AccountSumUtils />

			<Typography variant="body2">Market Overview</Typography>
			<MarketOverview
				colorTheme="dark"
				height={400}
				width="100%"
				showFloatingTooltip></MarketOverview>
			<Typography variant="body2">Crypto Market</Typography>
			<CryptoCurrencyMarket
				colorTheme="dark"
				width="100%"
				height={400}></CryptoCurrencyMarket>

			<Typography variant="body2">Stock Market</Typography>
			<StockMarket colorTheme="dark" height={400} width="100%"></StockMarket>
			{/* <Typography variant="body2">News Update</Typography>
			<Timeline
				colorTheme="dark"
				feedMode="market"
				market="crypto"
				height={400}
				width="100%"></Timeline> */}
		</Box>
	);
}

UDMktOverviewUi.propTypes = {
	pathname: PropTypes.string.isRequired,
};
